<template>
<div class="chapter">
<div class="inner_page">
<a id="page_2">
<p class="front_">Front Cover: A Cassini image of Saturn’s moon Mimas with the outer part of the planet’s A ring and the narrow F ring in the background. Mimas is one of many moons that gravitationally interact with the rings to produce wave structures. See the article <em class="italic">The Cassini-Huygens Mission to the Saturn System</em> for a summary of results from this mission. (NASA/JPL-Caltech/Space Science Institute)</p>
</a><a id="page_3">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Front.vue?54bddbe6